import styled from '@emotion/styled'

import type { FC } from 'react'

import SearchBar from '@segment/matcha/components/SearchBar'
import type { SearchBarProps } from '@segment/matcha/components/SearchBar/SearchBar'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

const copy = {
  heading: <>Explore popular solutions to&nbsp;empower every team</>,
  overline: `Recipes`,
}

interface HeroProps {
  query: SearchBarProps[`value`]
  onQueryChange: (newQuery: NonNullable<SearchBarProps[`value`]>) => void
  isQueryLoading: SearchBarProps[`isLoading`]
}

const Hero: FC<HeroProps> = ({ query, onQueryChange, isQueryLoading }) => {
  return (
    <Wrapper>
      <StyledHeroRecipeBase variant="centered" copyVariant="wide">
        <HeroRecipe.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
          </CopyTextBase>
        </HeroRecipe.Copy>
        <StyledHeroContents>
          <SearchBar
            aria-label="Search recipes"
            name="recipes"
            placeholder="Search recipes..."
            value={query}
            onChange={(_e, value) => onQueryChange(value ?? ``)}
            onClear={() => onQueryChange(``)}
            isLoading={isQueryLoading}
          />
        </StyledHeroContents>
      </StyledHeroRecipeBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroRecipeBase = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 80px;
      padding-bottom: 80px;
    }
  }
`

const StyledHeroContents = styled(HeroRecipe.Contents)`
  max-width: 520px;
`

export default Hero
